import React from 'react';
import { workouts } from '../data/workoutData';

const WorkoutSelector = ({ onSelectWorkout }) => {
  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Select a Workout Day</h2>
      <div style={styles.grid}>
        {workouts.map((workout) => (
          <button
            key={workout.id}
            onClick={() => onSelectWorkout(workout)}
            style={styles.button}
          >
            <span style={styles.emoji}>{workout.emoji}</span>
            <span style={styles.dayName}>{workout.day}</span>
            <span style={styles.workoutName}>{workout.name}</span>
            <small style={styles.focusText}>{workout.focus}</small>
          </button>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: '20px',
    textAlign: 'center',
  },
  heading: {
    fontSize: '1.8em',
    marginBottom: '30px',
    color: '#333',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', // Responsive grid
    gap: '20px',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  button: {
    backgroundColor: '#fff',
    border: '2px solid #007bff',
    borderRadius: '10px',
    padding: '25px 20px',
    cursor: 'pointer',
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    color: '#333',
    fontSize: '1em',
    minHeight: '180px', // Ensure buttons have a good height
  },
  emoji: {
    fontSize: '2.5em',
    marginBottom: '15px',
  },
  dayName: {
    fontSize: '1.4em',
    fontWeight: 'bold',
    color: '#007bff',
    marginBottom: '5px',
  },
  workoutName: {
    fontSize: '1.1em',
    fontWeight: '500',
    marginBottom: '10px',
  },
  focusText: {
    fontSize: '0.9em',
    color: '#555',
    lineHeight: 1.4,
  },
};

export default WorkoutSelector; 